import React, { useState } from 'react';
import { Button, Menu, MenuItem } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

/**
 * @param {Object} props
 * @param {Object} props.icon
 * @param {string} props.title
 * @param {Function} props.onClickFunc
 * @param {boolean} [props.disabled=false]
 */
function MakeMenuItem({
  icon, title, onClickFunc, disabled = false,
}) {
  return (
    <MenuItem onClick={onClickFunc} key={title} disabled={disabled}>
      {icon}
      &nbsp;
      {title}
    </MenuItem>
  );
}

/**
 * @param {Object} props
 * @param {Array<*>} props.menuItems
 * @param {string} props.title
 * @param {string} [props.buttonVariant='contained']
 */
export function MenuButton({ menuItems, title, buttonVariant = 'contained' }) {
  return (
    <ComponentMenuButton title={title} buttonVariant={buttonVariant}>
      {menuItems.map((item) => (MakeMenuItem(item)))}
    </ComponentMenuButton>
  );
}

/**
 * @param {Object} props
 * @param {Array<*>} props.children
 * @param {string} props.title
 * @param {string} [props.buttonVariant='contained']
 */
export function ComponentMenuButton({ children, title, buttonVariant = 'contained' }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        id={`${title}-button`}
        variant={buttonVariant}
        aria-controls={openMenu ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        {title}
      </Button>
      <Menu
        id={`${title}-menu`}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        slotProps={{
          list: {
            'aria-labelledby': `${title}-button`,
          },
        }}
      >
        {children}
      </Menu>
    </>
  );
}
